import type { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

import Link from '@mui/material/Link';
import SvgIcon from '@mui/material/SvgIcon';

import { ReactComponent as ExitIcon } from 'img/site/site_switch_user_exit.svg';

import { AuthActions } from 'common/auth/actions';

interface Props {
    label: string;
    isRespondentSession?: boolean;
}

export const DeviceHandoffExitLink = ({ label, isRespondentSession = false }: Props): ReactElement => {
    const dispatch = useDispatch();

    return (
        <div className="switch_user_exit_block">
            <div className={`switch_user_exit_container ${isRespondentSession ? 'patient' : ' '}`}>
                <Link
                    component="button"
                    className="switch-user-exit-link"
                    data-testid="device-handoff-exit-link"
                    onClick={(): void => {
                        dispatch(AuthActions.logoutRequest());
                    }}
                >
                    <SvgIcon className="switch_user_exit_icon" viewBox="0 0 16 16" component={ExitIcon} />
                    {label}
                </Link>
            </div>
        </div>
    );
};
